// extracted by mini-css-extract-plugin
module.exports = {"tags":"tag-list-module--tags--O_Obx"};